import { sum } from "d3-array";
import { hasKey, round, checkTypeOfKey } from "../../exports/helpers.js";
export default function getSum(data, key, nbDigits = 2, nbTestedValues = 10000, verbose = false) {
    hasKey(data, key);
    checkTypeOfKey(data, key, "number", 1, nbTestedValues, verbose);
    const result = sum(data, (d) => d[key]);
    return result ? round(result, nbDigits) : result;
}
//# sourceMappingURL=getSum.js.map